import React, {useEffect} from 'react'
import Select from 'react-select'
import { useForm } from "react-hook-form";
import FormGroup from 'components/Form/FormGroup'
import FormImage from 'components/Form/FormImage'
import Spinner from 'react-bootstrap/Spinner'
import * as Yup from 'yup'
import { DevTool } from "react-hook-form-devtools";
import * as moment from 'moment-timezone'
import "pages/partnerInformation.scss";

const htmlPlainText = (html) => {

    console.log("html", html)
    html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
    html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
    html = html.replace(/<\/div>/ig, '\n');
    html = html.replace(/<\/li>/ig, '\n');
    html = html.replace(/<li>/ig, '  *  ');
    html = html.replace(/<\/ul>/ig, '\n');
    html = html.replace(/<\/p>/ig, '\n');
    html = html.replace(/<br\s*[\/]?>/gi, "\n");
    html = html.replace(/<[^>]+>/ig, '');

    if (html.length < 20) {
        return ""
    }

    return html
}

const timezoneOptions = moment.tz.zonesForCountry('US').concat(moment.tz.zonesForCountry("CA")).concat(moment.tz.zonesForCountry('AU')).concat(moment.tz.zonesForCountry("FR")).concat(moment.tz.zonesForCountry("ES")).concat(moment.tz.zonesForCountry("FR")).concat(moment.tz.zonesForCountry("GB")).concat(moment.tz.zonesForCountry("IT")).map(val => {
    return {
        label: val,
        value: val
    }
})

export const symbolFromCurrency = (currency) => {
    if (currency === "EUR") {
        return "€"
    } else if (currency === "GBP") {
        return "£"
    }
    return "$"
}

const currencyOptions = [
    {
        label: "USD",
        value: "USD"
    },
    {
        label: "AUD",
        value: "AUD"
    },
    {
        label: "CAD",
        value: "CAD"
    },
    {
        label: "EUR",
        value: "EUR"
    },
    {
        label: "GBP",
        value: "GBP"
    }
]

function PartnerInformationForm(props) {

    const { user } = props;
    const { handleFormSubmission } = props;

    console.log("USER: ", user)

    const { register, control, handleSubmit, setValue, getValues, formState, errors } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            pageName: Yup.string().required('This field is required'),
            widgetName: Yup.string().required('This field is required'),
            region: Yup.string(),

            preparationDirections: Yup.string(),
            cancellationPolicyHours: Yup.number(),
            // absorbFees: Yup.boolean(),
            liabilityWaiverText: Yup.string(),
            liabilityWaiverTextHTML: Yup.string(),
            timezoneSetting: Yup.string().required("please select a timezone"),
            // currency: Yup.string().required("please select a currency")
        }),
        defaultValues: {
            widgetName: user.widgetName ?? "",
            pageName: user.instructorProfile?.pageName ?? "",
            bio: user.instructorProfile?.aboutMe?.story ?? "",
            region: user.region ?? "",
            // introUrl: user.instructorProfile?.introUrl ?? "",
            instagram: user.instructorProfile?.instagram ?? "",
            spotify: user.instructorProfile?.spotify ?? "",

            preparationDirections: user.instructorProfile?.preparationDirections ?? "",
            cancellationPolicyHours: user.instructorProfile?.cancellationPolicyHours ?? 0,
            // absorbFees: user.instructorProfile?.absorbFees ?? false,
            liabilityWaiverText: user.instructorProfile?.liabilityWaiverText ?? "",
            liabilityWaiverTextHTML: user.instructorProfile?.liabilityWaiverTextHTML ?? user.instructorProfile?.liabilityWaiverText ?? "",
            timezoneSetting: user.instructorProfile?.timezoneSetting ?? "America/Los_Angeles",
            // currency: user.instructorProfile?.currency ?? "USD"
        }
    });

    const { dirty } = formState;

    const onSubmit = (data) => {

        if (data.liabilityWaiverTextHTML) {
            var liabilityWaiverTextHTML_copy = (' ' + data.liabilityWaiverTextHTML).slice(1);
            data.liabilityWaiverTextHTML = liabilityWaiverTextHTML_copy
            data.liabilityWaiverText = htmlPlainText(liabilityWaiverTextHTML_copy)

            if (data.liabilityWaiverTextHTML.length < 20) {
                data.liabilityWaiverTextHTML = ""
            }
        }

        if (handleFormSubmission) {
            var dataUpdate = {}
            dataUpdate.partnerLogo = data.partnerLogo
            dataUpdate.widgetName = data.widgetName
            dataUpdate.region = data.region
            dataUpdate.partnerImage = data.partnerImage
            dataUpdate.partnerLogo = data.partnerLogo
            dataUpdate.instructorProfile = {
                ...user.instructorProfile,
                pageName: data.pageName,
                aboutMe: {
                    ...user.aboutMe,
                    story: data.bio,
                },
                instagram: data.instagram,
                spotify: data.spotify,
                preparationDirections: data.preparationDirections,
                cancellationPolicyHours: data.cancellationPolicyHours,
                liabilityWaiverText: data.liabilityWaiverText ?? "",
                liabilityWaiverTextHTML: data.liabilityWaiverTextHTML ?? "",
                timezoneSetting: data.timezoneSetting,
            }

            handleFormSubmission(dataUpdate)
        }
    }
    const cities = ["Toronto", "New York","Los Angeles", "Melbourne", "Paris", "London", "Ireland", "Boulder", "Halifax", "Cape Cod", "Salem", "North Carolina", "Chicago", "Quito, Ecuador", "Regina, Saskatchewan","Houston","Phoenix","Philadelphia","San Antonio","San Diego","Dallas","San Jose","Austin","Fort Worth","Jacksonville","Columbus","Charlotte","San Francisco","Indianapolis","Seattle","Denver","Washington","Boston","El Paso","Nashville","Detroit","Portland","Las Vegas","Oklahoma City","Memphis","Louisville","Baltimore","Milwaukee","Albuquerque","Tucson","Fresno","Mesa","Atlanta","Sacramento","Kansas City","Miami","Colorado Springs","Raleigh","Omaha","Long Beach","Virginia Beach","Minneapolis","Oakland","Tampa","Arlington","Tulsa","Bakersfield","New Orleans","Wichita","Aurora","Cleveland","Anaheim","Honolulu","Riverside","San Juan Zona Urbana","Santa Ana","Henderson","Lexington","Corpus Christi","Stockton","St. Paul","Cincinnati","Irvine","Greensboro","Pittsburgh","Lincoln","St. Louis","Orlando","Plano","Anchorage","Newark","Durham","Chula Vista","St. Petersburg","Jersey City","Fort Wayne","Toledo","Chandler","Laredo","Madison","Scottsdale","Lubbock","Reno","Gilbert","Buffalo","Glendale","North Las Vegas","Winston Salem","Chesapeake","Garland","Irving","Hialeah","Norfolk","Fremont","Boise","Paradise","Richmond", "Monterey"]
    const cityOptions = cities.map(val => {return {value: val, label: val}})

    useEffect(() => {
        register({ name: 'partnerLogo'})
        register({ name: 'partnerImage'})
    }, [register])

    // console.log(errors)

    return (<>
        <form className="partnerInformationForm" onSubmit={handleSubmit(onSubmit)}>
            <section>
                <div className="row">
                    <div className="col-md-10">
                    </div>
                    <div className="col-md-2">
                        <button disabled={!dirty || props.isSaving} type="submit" className="btn btn-primary">
                        
                            <span>{"Save changes"}</span>

                            {props.isSaving && (
                                <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                                >
                                <span className="sr-only">Saving...</span>
                                </Spinner>
                            )}
                        </button>
                        <a href={"https://sutrapro.com/" + (user.widgetName ?? "")} target="_blank">
                            <button type="button" className="btn btn-link">Preview page</button>
                        </a>
                        
                    </div>
                </div>
            </section>

            <section>
                <FormImage
                fullSize
                imageUrl={user.instructorProfile?.partnerImageUrl}
                name="partnerImage"
                label="Profile photo"
                defaultName={user.instructorProfile?.pageName}
                sublabel={"(Square image recommended)"}
                register={register}
                fileSelection={(file) => setValue('partnerImage', file)}
                />

                <FormGroup
                fullSize
                type="text"
                name="pageName"
                label="Name of your page"
                placeholder="First name, studio name, etc."
                register={register}
                error={errors.pageName}
                />

                <FormGroup
                fullSize
                type="text"
                name="widgetName"
                label="Your scheduling URL"
                sublabel="Changing your scheduling URL will change the links to your public page, including embeddable widgets"
                placeholder=""
                prepending={["sutrapro.com/"]}
                register={register}
                />

            </section>

            <hr></hr>

            <section>

                <div className="d-flex d-row align-items-center">
                    <h4 className="m-0">About me</h4>
                    <p className="m-0 pt-1">&nbsp;- Share more about yourself with your students</p>
                    
                </div>
            </section>

            <section>
                <div className="row">
                    <h6 className="col-md-12">Bio</h6>
                    <p className="col-md-12">This is how you stand out from the crowd. Share with your students where you’re from, what food you like to eat, your teaching background and more!</p>
                </div>
                

                <div className="form-group row">
                    <div className="col-md-12">
                        <textarea ref={register} rows="8" type="textarea" placeholder="" name="bio" className="form-control" />
                    </div>
                </div>

                <FormGroup 
                fullSize
                select
                options={cityOptions}
                type="text"
                name="region"
                label="Region"
                sublabel="Where you are"
                placeholder="Select a city"
                control={control}
                setValue={setValue}
                getValues={getValues}
                />

                <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                        <h6>Social</h6>
                        <small>connect your social media links to your profile</small>
                    </label>
                    <div className="col-md-9">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <div className="input-group-text">Instagram</div>
                                <div className="input-group-text">@</div>
                            </div>
                            <input ref={register} type="text" placeholder="" name="instagram" className="form-control" />
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <div className="input-group-text">Spotify</div>
                                <div className="input-group-text">@</div>
                            </div>
                            <input ref={register} type="text" placeholder="" name="spotify" className="form-control" />
                        </div>
                    </div>
                    
                </div>

                {/* <FormGroup
                fullSize
                type="text"
                name="introUrl"
                label="Intro video"
                sublabel="Showcase your personality!"
                placeholder="Video URL"
                register={register}
                /> */}
            </section>

            <hr></hr>

            <section>

                <div className="d-flex d-row align-items-center">
                    <h4 className="m-0">Business Settings</h4>
                    
                </div>
            </section>

            <section>

                <FormImage
                fullSize
                style={{width: "125px", height: "50px"}}
                imageUrl={user.instructorProfile?.partnerLogoUrl}
                name="partnerLogo"
                label="Brand Logo"
                sublabel="This will appear at the header of confirmation emails (recommended 250px x 100px)"
                defaultName={user.instructorProfile?.pageName}
                // sublabel={"(256px x 256px recommended)"}
                register={register}
                fileSelection={(file) => setValue('partnerLogo', file)}
                />

                <FormGroup 
                fullSize
                select
                options={timezoneOptions}
                type="text"
                name="timezoneSetting"
                label="Email Timezone Settings"
                sublabel="Confirmation emails will display this timezone"
                placeholder="Select a timezone"
                control={control}
                setValue={setValue}
                getValues={getValues}
                />

                <FormGroup
                fullSize
                texteditor
                type="text"
                name="preparationDirections"
                label="Confirmation Email Body"
                sublabel="Let your students know how to prepare for class."
                placeholder="Let your students know how to prepare for class."
                // prepending={["sutrapro.com"]}
                register={register}
                control={control}
                setValue={setValue}
                getValues={getValues}
                />

                <FormGroup
                fullSize
                type="hours"
                name="cancellationPolicyHours"
                label="Cancellation Policy"
                sublabel="How many hours before class can a user cancel? By default all classes are non-refundable."
                placeholder="optional"
                register={register}
                />
                <FormGroup
                fullSize
                type="text"
                texteditor
                name="liabilityWaiverTextHTML"
                label="Waiver of Liability"
                sublabel="This helps protect you if a student injures themeself."
                placeholder="optional"
                register={register}
                innerHtml={(<span><a target="_blank" href="https://www.yogajournal.com/teach/why-yoga-teachers-need-liability-waivers">Why use a liability waiver</a></span>)}
                control={control}
                setValue={setValue}
                getValues={getValues}
                />

            </section>

            {/* <input type="submit"/> */}
            <div className="row">
                <div className="col-md-10 d-flex justify-content-end">
                    <button disabled={!dirty} type="submit" className="btn btn-primary">Save changes</button>
                </div>
            </div>
            

        </form>
        <DevTool control={control} />
    </>)
}

export default PartnerInformationForm;